import React from 'react';
import { CTASection } from '../../components/CTASection';
export function ServicesCTA() {
  return <section className="py-20 bg-white" data-id="element-573">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-574">
        <CTASection headline="Let's Build Something Together" body="Ready to discuss your software development needs? We'd love to hear about your project." buttonText="Get in Touch" buttonLink="/contact" variant="dark" data-id="element-575" />
      </div>
    </section>;
}